/* Theme custom file */
class PriceLineTooltip extends HTMLElement {
  connectedCallback() {
    this.trigger = this.querySelector('.price-line__tooltip-trigger');
    this.tooltip = this.querySelector('.price-line__tooltip');

    if (!this.trigger || !this.tooltip) return;

    this.handleTriggerClick = this.handleTriggerClick.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);

    this.trigger.addEventListener('click', this.handleTriggerClick);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.handleTriggerClick);
    this.close();
  }

  handleTriggerClick(event) {
    event.stopPropagation();
    const isOpen = this.trigger.getAttribute('aria-expanded') === 'true';

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.trigger.setAttribute('aria-expanded', 'true');
    this.tooltip.hidden = false;
    this.updatePosition();
    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  updatePosition() {
    const triggerRect = this.trigger.getBoundingClientRect();
    const tooltipRect = this.tooltip.getBoundingClientRect();
    const spaceAbove = triggerRect.top;
    const needsFlip = spaceAbove < tooltipRect.height + 8;

    this.tooltip.classList.toggle('price-line__tooltip--below', needsFlip);
  }

  close() {
    this.trigger?.setAttribute('aria-expanded', 'false');
    if (this.tooltip) this.tooltip.hidden = true;
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleOutsideClick(event) {
    if (!this.contains(event.target)) {
      this.close();
    }
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}

customElements.define('price-line-tooltip', PriceLineTooltip);
